import { TextInput } from '@ironscales/design-system'

export default TextInput

export const SIZES = TextInput.SIZES
export const STATUSES = TextInput.STATUSES
